import { render, staticRenderFns } from "./enterpriseOrderInfoRefund.vue?vue&type=template&id=236e36e6&scoped=true&"
import script from "./enterpriseOrderInfoRefund.vue?vue&type=script&lang=js&"
export * from "./enterpriseOrderInfoRefund.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseOrderInfoRefund.vue?vue&type=style&index=0&id=236e36e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e36e6",
  null
  
)

export default component.exports